const videoGalleryVideo = {
  displayField: 'videoSubject',
  name: 'Video Gallery Video',
  description: '',
  fields: [
    {
      id: 'videoReference',
      name: 'Video Reference',
      type: 'Link',
      localized: false,
      required: false,
      validations: [{ linkContentType: ['video'] }],
      disabled: false,
      omitted: false,
      linkType: 'Entry',
    },
    {
      id: 'videoIcon',
      name: 'Video Icon',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset',
    },
    {
      id: 'videoSubject',
      name: 'Video Subject',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
    },
    {
      id: 'videoSubjectDetails',
      name: 'Video Subject Details',
      type: 'Array',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: { type: 'Symbol', validations: [] },
    },
    {
      id: 'muteVideo',
      name: 'Mute Video',
      type: 'Boolean',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
    },
  ],
  sys: {
    id: 'videoGalleryVideo',
    version: 16,
    updatedAt: '2023-08-03T14:44:08.849Z',
  },
};
export default videoGalleryVideo;
